import { dynamicValues } from '@/utils/dynamicValues';

// Definiere einen Typ für die Schlüssel von dynamicValues
type DynamicValueKey = keyof typeof dynamicValues;

/**
 * Ersetzt Platzhalter in einem String mit dynamischen Werten
 */
export function replacePlaceholders(text: string): string {
  if (!text) return '';

  return text.replace(/\{(\w+)\}/g, (match, key) => {
    // Prüfen ob der key in dynamicValues existiert
    if (Object.prototype.hasOwnProperty.call(dynamicValues, key)) {
      // Typensichere Variante mit Schlüssel-Check
      const dynamicKey = key as DynamicValueKey;
      const valueOrFunction = dynamicValues[dynamicKey];

      const value = typeof valueOrFunction === 'function'
        ? valueOrFunction()
        : valueOrFunction;
      return String(value);
    }
    return match; // Unbekannte Platzhalter unverändert lassen
  });
}

/**
 * Ersetzt Platzhalter in allen String-Eigenschaften eines Objekts rekursiv
 */
export function replacePlaceholdersInObject<T>(obj: T): T {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  // Direkter String-Check als erster Fall
  if (typeof obj === 'string') {
    return replacePlaceholders(obj) as unknown as T;
  }

  // Array-Behandlung verbessert
  if (Array.isArray(obj)) {
    return obj.map(item => {
      if (typeof item === 'string') {
        return replacePlaceholders(item);
      }
      return replacePlaceholdersInObject(item);
    }) as unknown as T;
  }

  const result = { ...obj } as Record<string, unknown>;

  for (const key in result) {
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      const value = result[key];

      if (typeof value === 'string') {
        result[key] = replacePlaceholders(value) as unknown;
      } else if (typeof value === 'object' && value !== null) {
        result[key] = replacePlaceholdersInObject(value);
      }
    }
  }

  return result as unknown as T;
}

// Export für globale Verwendung in anderen Dateien
export const PlaceholderRegistry = {
  replace: replacePlaceholders,
  replaceInObject: replacePlaceholdersInObject
};